module.exports = __webpack_public_path__ + "img/malawi.317a10f4.svg";